import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// Insights Redux States
import {
  GET_INSIGHTS,
  GET_INSIGHT,
  CREATE_INSIGHT,
  EDIT_INSIGHT,
  DELETE_INSIGHT,
} from "./actionTypes";
import {
  setInsights,
  apiError,
  setInsight,
  createInsightSuccess,
  editInsightSuccess,
  deleteInsightSuccess,
} from "./actions";

//Include Both Helper File with needed methods
import axios from "axios";

function* getInsights({ payload: { idCompany, page, qnt, name, isForm } }) {
  try {
    const response = yield call(
      axios.get,
      `/insights?${
        (idCompany ? `&client_id=${idCompany}` : "") +
        (page ? `&page=${page}` : "") +
        (qnt ? `&qtd=${qnt}` : "") +
        (name ? `&name=${name}` : "") +
        (isForm ? `&form=true` : "")
      }`
    );
    if (
      (response.status >= 200 || response.status <= 299) &&
      response.data &&
      response.data.data
    ) {
      yield put(setInsights(response.data.data, qnt));
    } else throw response.data;
  } catch (error) {
    let message = error.message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          //TODO: remover esta verificação quando o backend enviar array vazio com status 200 quando nao ha objetos
          if (error.response.data && typeof error.response.data === "object") {
            message = error.response.data.message;
          } else {
            message = "Sorry! the page you are looking for could not be found";
          }
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}

function* createInsight({ payload: { newFields } }) {
  try {
    const response = yield call(axios.post, "/insights", newFields);
    if ((response.status >= 200 || response.status <= 299) && response.data) {
      let message = response.data.message;
      yield put(createInsightSuccess(message));
    } else {
      throw response.data;
    }
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}
function* getInsight({ payload: { idInsight } }) {
  try {
    const response = yield call(
      axios.get,
      `/insights?&form=true${idInsight ? `&id=${idInsight}` : ""}`
    );
    if (
      (response.status >= 200 || response.status <= 299) &&
      response.data &&
      response.data.data
    ) {
      yield put(setInsight(response.data.data));
    } else throw response.data;
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}
function* editInsight({ payload: { idInsight, newFields } }) {
  try {
    const response = yield call(
      axios.patch,
      `/insights?&id=${idInsight}`,
      newFields
    );
    if ((response.status >= 200 || response.status <= 299) && response.data) {
      let message = response.data.message;
      yield put(editInsightSuccess(message));
    } else throw response.data;
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}

function* deleteInsight({ payload: { idInsight } }) {
  try {
    const response = yield call(axios.delete, `/insights?id=${idInsight}`);
    if ((response.status >= 200 || response.status <= 299) && response.data) {
      let message = response.data.message;
      yield put(deleteInsightSuccess(message));
    } else throw response.data;
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}

export function* watchInsight() {
  yield takeEvery(GET_INSIGHTS, getInsights);
}
export function* watchCreateInsight() {
  yield takeEvery(CREATE_INSIGHT, createInsight);
}
export function* watchGetInsight() {
  yield takeEvery(GET_INSIGHT, getInsight);
}
export function* watchEditInsight() {
  yield takeEvery(EDIT_INSIGHT, editInsight);
}
export function* watchDeleteInsight() {
  yield takeEvery(DELETE_INSIGHT, deleteInsight);
}
function* authSaga() {
  yield all([
    fork(watchInsight),
    fork(watchGetInsight),
    fork(watchCreateInsight),
    fork(watchEditInsight),
    fork(watchDeleteInsight),
  ]);
}

export default authSaga;
